<template>
  <div class="c-card">
    <div v-if="value" class="card">
      <p>已选:{{ anchorName }}</p>
      <div class="card-hover">
        <Button class="update-button" size="large" @click="modal = true">替换</Button>
      </div>
    </div>
    <Button type="primary" @click="modal = true" v-else>资产选择</Button>
    <AnchorData
      v-model="modal"
      :account="account"
      :package-android="packageAndroid"
      :package-ios="packageIos"
      @on-select="handleAnchor"
      @on-close="modal = false"
    ></AnchorData>
  </div>
</template>
<script>
import AnchorData from './anchor-data.vue'
export default {
  name: 'AnchorSelect',
  components: { AnchorData },
  props: {
    value: {
      type: String
    },
    account: {
      type: Number
    },
    packageAndroid: {
      type: [String, Object]
    },
    packageIos: {
      type: [String, Object]
    },
    anchorName: {
      type: String
    }
  },
  computed: {
    anchor: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      modal: false
    }
  },
  methods: {
    handleAnchor(param) {
      this.modal = false
      const { anchor_id, anchor_name } = param[0]
      this.anchor = String(anchor_id)

      this.$emit('update:anchorName', anchor_name)
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  width: 220px;
  height: 45px;
  padding: 6px 0;
  border: 1px rgba(85, 85, 85, 0.2) solid;
  border-radius: 5px;
  margin-bottom: 10px;

  p {
    font-size: 14px;
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-hover {
    top: 0;
    width: 220px;
    height: 45px;
    position: absolute;
    display: flex;
    justify-content: center;
    opacity: 0;
    background: rgba(85, 85, 85, 0.8);
    border-radius: 5px;

    &:hover {
      // background: red;
      opacity: 1;
    }

    .update-button {
      width: 60px;
      height: 30px;
      margin: 8px;
      cursor: auto;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
